module.exports = __webpack_public_path__ + "img/banner.de700cbd.png";